import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  USER_ROLE_ADMIN,
} from 'common/userRoles';

import {
  SCREEN_ID_LEASE_DRAFT_CONFIG,
} from 'client/constants/screenIds';

import {
  SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION_LIST,
  SR_API_ACTION_PARTNER_GET_LIST,
} from 'api/actionTypes';

import allowedRoles from 'client/helpers/allowedRoles';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withApiState from 'client/helpers/withApiState';
import branch from 'client/core/branch';
import LeaseActions from 'client/actions/Lease';
import PartnerActions from 'client/actions/Partner';

import SrLeaseDraftConfigurationsAdmin from 'client/components/SrLeaseDraftConfigurationsAdmin';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_LEASE_DRAFT_CONFIG)
@withApiState({
  getLeaseDraftConfigListApiState: {
    action: SR_API_ACTION_LEASE_DRAFT_GET_PARTNER_CONFIGURATION_LIST,
  },
  getPartnersListApiState: {
    action: SR_API_ACTION_PARTNER_GET_LIST,
  },
})
@withScrollToTop
@branch({
  leaseDraftConfigurationList: ['leases', 'configurationsList'],
  partnerList: ['partners', 'list'],
})
class AdminLeaseDraftConfigPage extends Component {
  static propTypes = {
    getLeaseDraftConfigListApiState: PropTypes.object.isRequired,
    getPartnersListApiState: PropTypes.object.isRequired,
    partnerList: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
  }

  static fetchData(match, inject) {
    return Promise.all([
      LeaseActions.getPartnerDraftConfigurationList(inject),
      PartnerActions.getPartnerList(inject),
    ]);
  }

  static getPageMetadata = () => ({
    pageTitle: 'Lease Draft Configuration | Sunroom Rentals',
  })

  render() {
    const {
      leaseDraftConfigurationList,
      partnerList,
      getLeaseDraftConfigListApiState,
      getPartnersListApiState,
      isTransitioning,
      dispatch,
    } = this.props;

    if (
      getLeaseDraftConfigListApiState.inProgress
      || getPartnersListApiState.inProgress
      || isTransitioning
    ) {
      return (
        <div className='loading-gif' />
      );
    }

    return (
      <SrBox backgroundColor='#F7F7F7' minHeight='100vh'>
        <SrBox padding='0px 30px 30px' maxWidth='1440px' margin='0 auto'>
          <SrBox
            backgroundColor='#F7F7F7'
            paddingTop='33px'
          >
            <SrText
              font='greycliff'
              display='block'
              fontSize='28px'
              weight='700'
            >
              Lease Draft Configuration
            </SrText>
          </SrBox>
          <SrLeaseDraftConfigurationsAdmin
            leaseDraftConfigurationList={leaseDraftConfigurationList}
            partnerList={partnerList}
            dispatch={dispatch}
          />
        </SrBox>
      </SrBox>
    );
  }
}

AdminLeaseDraftConfigPage.displayName = 'AdminLeaseDraftConfigPage';

export default AdminLeaseDraftConfigPage;
